import { render } from "./BDS.vue?vue&type=template&id=bed7e3e8&scoped=true"
import script from "./BDS.vue?vue&type=script&lang=js"
export * from "./BDS.vue?vue&type=script&lang=js"

import "./BDS.vue?vue&type=style&index=0&id=bed7e3e8&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bed7e3e8"]])

export default __exports__